import Link from 'next/link'
import { styled } from 'styled-components'

import { zIndexes } from '../../../theme/zIndexes'
import { Logo } from '../../GenderFunnel/Header/Logo'
import { HeaderUser } from '../../GenderFunnel/Header/User/HeaderUser'

export const StyledContainer = styled.div`
  position: fixed;
  z-index: ${zIndexes.header};
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const StyledTopContainer = styled.div`
  display: flex;
  min-height: ${({ theme }) => theme.sizes.headerHeight}rem;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem;
  background: ${({ theme }) => theme.colors['N Surface/Base']};
  gap: 1rem;
`

export const StyledLogoLink = styled(Link)`
  display: flex;
  width: min-content;
`

export const StyledLogo = styled(Logo)`
  flex: 0 0 auto;
`

export const StyledHeaderUser = styled(HeaderUser)`
  position: relative;
  overflow: hidden;
  width: auto;
  max-width: 100%;
  justify-self: flex-end;
`
